import { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Pagination,
  Stack,
  TextField,
  InputLabel,
} from "@mui/material";
import Colors from "../../assets/styles";
import AuthServices from "../../apis/AuthServices";
import moment from "moment";

export default function AllocationList() {
  const [page, setPage] = useState(1);  // Start from page 1 (for pagination)
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [isLoading, setIsLoading] = useState(false);
  const [locomotives, setLocomotives] = useState([]);
  const [filteredLocomotives, setFilteredLocomotives] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [count, setCount] = useState(0);
  const [offset, setOffset] = useState(0); // offset for API request
  const [limit, setLimit] = useState(50);  // default rows per page

  // Function to handle page changes
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    setOffset((newPage - 1) * rowsPerPage);  // Update offset based on the new page
    getAllocationList((newPage - 1) * rowsPerPage, rowsPerPage);  // Fetch data with new offset
  };

  // Function to get allocation list data
  const getAllocationList = async (offset = 0, limit = 30) => {
    try {
      const result = await AuthServices.allocationList(offset, limit);
      if (result.IsSuccess) {
        setLocomotives(result?.Response?.data);
        setFilteredLocomotives(result.Response.data);
        setCount(result?.Response?.TotalCount);
      }
    } catch (error) {
      console.error("Error fetching allocation list:", error);
    }
  };

  useEffect(() => {
    getAllocationList(offset, limit); // Fetch data on initial load
  }, [offset, limit]);

  // Search function to filter locomotives
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    const filtered = locomotives.filter(
      (locomotive) =>
        locomotive.LocomotiveNumber.toString().includes(value) ||
        locomotive.TrainName?.toLowerCase().includes(value) ||
        locomotive.StationName?.toLowerCase().includes(value) ||
        locomotive.Remarks?.toLowerCase().includes(value) 
    );
    setFilteredLocomotives(filtered);
  };

  return (
    <>
      <Box sx={{ mb: 3  ,display:'flex' ,justifyContent:'space-between',alignItems:'center'}}>
        <Typography
          variant="h5"
          component="h1"
          sx={{
            color: Colors.primary,
            fontWeight: 500,
            letterSpacing: "1px",
            textTransform:"uppercase"
          }}
        >
        Locomotive Allocation List
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{textTransform:"uppercase"}}>
        Train / Locomotive Allocation List
        </Typography>
      </Box>

      <Container
        maxWidth="xl"
        sx={{
          mt: 2,
          boxShadow: "0px 8px 24px 0 #4545501A",
          py: 2,
          backgroundColor: Colors.white,
          borderRadius:"12px"
        }}
      >
        {/* <Box sx={{ mb: 2 }}>
          <InputLabel>Search</InputLabel>
          <TextField
            sx={{ width: { md: "50%", sm: "100%", xs: "100%" } }}
            placeholder="Search by Locomotive Number, Station Name, or Remarks"
            value={searchTerm}
            onChange={handleSearch}
          />
        </Box> */}

        <TableContainer sx={{ height: "auto", overflowX: "auto" }}>
             <Typography
       
      
          sx={{
            color: Colors.primary,
            fontWeight: 500,
            letterSpacing: "1px",
            fontSize:"16px",
            mb:2,
            textTransform:"uppercase"
          }}
        >
        Locomotive Allocation List
        </Typography>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: "rgb(19 62 2)" }}>
                <TableCell sx={{ color: "white", width: "5%" }}>#</TableCell>
                <TableCell sx={{ color: "white", width: "25%" }}>Date</TableCell>
                <TableCell sx={{ color: "white", width: "20%" }}>Time</TableCell>
                <TableCell sx={{ color: "white", width: "20%" }}>Train Name</TableCell>
                <TableCell sx={{ color: "white", width: "20%" }}>Locomotive</TableCell>
                <TableCell sx={{ color: "white", width: "20%" }}>User Name</TableCell>
                <TableCell sx={{ color: "white", width: "20%" }}>Station Name</TableCell>
                <TableCell sx={{ color: "white", width: "20%" }}>Remarks</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : (
                filteredLocomotives.map((train, index) => (
                    <TableRow key={train.LocomotiveId}>
                      <TableCell>{index + 1 + (page - 1) * rowsPerPage}</TableCell>
                      <TableCell>{moment(train?.CreatedDate).format("DD MMMM YYYY")}</TableCell>
                      <TableCell>{moment(train?.CreatedDate).format("hh:mm:ss")}</TableCell>
                      <TableCell>{train?.TrainName}</TableCell>
                      <TableCell>{train?.LocomotiveNumber}</TableCell>
                      <TableCell>{train?.UserName || "-"}</TableCell>
                      <TableCell>{train?.StationName}</TableCell>
                      <TableCell>{train?.Remarks}</TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Stack direction="row" justifyContent="center" alignItems="center" sx={{ mt: 2 }}>
          <Pagination
            count={Math.ceil(count / rowsPerPage)}  // Divide total count by rows per page for pagination count
            page={page}
            onChange={handlePageChange}
            variant="outlined"
            shape="rounded"
            color="success"
            sx={{
              "& .MuiPaginationItem-root": {
                borderColor: "rgb(19, 62, 2)",
                color: "rgb(19, 62, 2)",
              },
              "& .MuiPaginationItem-page.Mui-selected": {
                bgcolor: "rgb(19, 62, 2)",
                color: "white",
              },
            }}
          />
        </Stack>
      </Container>
    </>
  );
}
